import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ShipmentsBoard } from '@/components/logistics/ShipmentsBoard';
import { ShipmentsExport } from '@/components/logistics/ShipmentsExport';
import { toast } from 'sonner';

const EMPTY = { name: '', email: '', phone: '', password: '' };

const Operators = ({ items, reload }) => {
  const [f, setF] = useState(EMPTY);
  const create = async () => {
    try { await api.post('/admin/logistics/operators', f); toast.success('Operador creado'); setF(EMPTY); reload(); }
    catch (e) {
      const d = e.response?.data?.detail;
      toast.error(d?.message || (Array.isArray(d) ? String(d[0]?.msg || '').replace(/^Value error,\s*/, '') : 'No se pudo crear'));
    }
  };
  const toggle = async (o) => {
    try { await api.patch(`/admin/logistics/operators/${o.user_id}`, { status: o.status === 'active' ? 'disabled' : 'active' }); reload(); }
    catch { toast.error('No se pudo cambiar'); }
  };
  return (
    <div className="mt-8 border border-slate-200 bg-white p-5" data-testid="operators-panel">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Operadores logísticos</div>
      <p className="mt-1 text-xs text-slate-500">Acceso solo a las recogidas y despachos que se les asignen; sin finanzas ni administración. Contraseña de mínimo 10 caracteres con letras y números.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {[['name', 'Nombre'], ['email', 'Correo'], ['phone', 'Celular (10 dígitos)'], ['password', 'Contraseña temporal']].map(([k, l]) => (
          <Input key={k} placeholder={l} type={k === 'password' ? 'password' : 'text'} value={f[k]} onChange={e => setF({ ...f, [k]: e.target.value })}
            className="rounded-none h-9 w-52" data-testid={`operator-${k}`} />
        ))}
        <Button className="rounded-none bg-slate-900 h-9" onClick={create} data-testid="operator-create">Crear operador</Button>
      </div>
      <ul className="mt-3 divide-y divide-slate-100 text-sm">
        {items.map(o => (
          <li key={o.user_id} className="flex items-center justify-between py-2" data-testid={`operator-row-${o.user_id}`}>
            <span>{o.name} · {o.email} · {o.phone}</span>
            <Button size="sm" variant="outline" className="rounded-none" onClick={() => toggle(o)} data-testid={`operator-toggle-${o.user_id}`}>
              {o.status === 'active' ? 'Desactivar' : 'Activar'}
            </Button>
          </li>
        ))}
        {!items.length && <li className="py-2 text-slate-400">Aún no hay operadores.</li>}
      </ul>
    </div>
  );
};

export default function AdminShipments() {
  const [ops, setOps] = useState([]);
  const loadOps = () => api.get('/admin/logistics/operators').then(r => setOps(r.data.items)).catch(() => {});
  useEffect(() => { loadOps(); }, []);
  return (
    <Layout>
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8" data-testid="admin-shipments-page">
        <Link to="/admin/configuracion/envios" className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Envíos y logística</Link>
        <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1">Recogidas y despachos</h1>
        <p className="mt-2 mb-5 text-sm text-slate-600">Pedidos pagados con envío gestionado por AutoMarket. Flujo: asignar responsable → programar recogida → recogido → registrar transportadora, guía y costo real → en tránsito → entregado. Al registrar el despacho el pedido queda «enviado»; al registrar la entrega se aplican las reglas habituales para liberar el desembolso.</p>
        <ShipmentsExport />
        <ShipmentsBoard isAdmin operators={ops} />
        <Operators items={ops} reload={loadOps} />
      </div>
    </Layout>
  );
}
